import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'
import React from 'react'

export const AppMotorTerms: React.FC = () => {

    const data = [
        {
            'type': 1,
            'content': 'TERMS OF USE',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'These Terms of Use apply to your use of our website, www.motorloan.my (“Website”) and our mobile application (“App”) (together known as the “Sites”). Please read the following Terms of Use carefully before using the Sites or creating an account ("Account") so that you are aware of your legal rights and obligations with respect to Shenma Credit Sdn. Bhd (Company No.: 201401009329/1085407-K), its affiliates and/or subsidiaries (individually and collectively, "Shenma", "we", "us" or "our").',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'By using our website or downloading our app, you confirm that you accept these Terms of Use and that you agree to comply with them. If you do not agree to these terms, you must not use our website or download our app. We operate the Sites to facilitate financial services (“Services”) by providing Shenma Credit Motorcycle Financing (“AITAB”). The Services include an online platform service that provides a place and opportunity for the sale of motor vehicles between the buyer (“Buyer”) and the Merchant (“Merchant”) (collectively “you”, “Users” or “Parties”).',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The actual contract for sale is directly between you and the Merchant and Shenma is not a party to that or any other contract between you and the Merchant and accepts no obligations in connection with any such contract. Parties to such transaction will be entirely responsible for the sales contract between them, including the listing of motor vehicles and warranty of purchase. Shenma is not involved in the transaction between you and the Merchant. Shenma may or may not pre-screen the Merchant or the content or information provided by the Merchant. Shenma cannot ensure that you and the Merchant will actually complete a transaction.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Shenma reserves the right to amend these Terms of Use from time to time at its absolute discretion. Each time you use the Sites, you should check these Terms of Use to ensure that you understand the terms that apply at that time.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Shenma also reserves the right to change, modify, suspend or discontinue all or any part of the Sites or the Services at any time, or upon notice where required by applicable laws. Shenma may release certain Services or features in beta version and such beta versions may not function properly or in the same manner as the final version, and Shenma shall not be liable for any issues arising from the use of such beta versions. Shenma may also impose limits on certain features or restrict your access to parts of, or the entirety of, the Sites or the Services at its sole discretion and without prior notice or liability.',
            'paddingLeft': '0px',
            'underline': false
        },

        {
            'type': 1,
            'content': '1. Use of Website',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1.1 Use of the Sites by Visitors:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may only use/browse the Sites in accordance with these Terms of Use and for lawful purposes which include complying with all applicable laws, regulations, and codes of practice within Malaysia or other jurisdiction from which you are accessing the Sites.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1.2 Use of the Sites by Applicants:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'To make a AITAB application, you must register for an Account established via the Sites. If you are under the age of 18 or the legal age for giving consent hereunder pursuant to the applicable laws in your country (the “Legal Age”), you must get permission from a parent or legal guardian to create an Account and that parent or legal guardian must agree to these Terms of Use. If you do not know whether you have reached the Legal Age, or do not understand this clause, please do not create an Account until you have asked your parent or legal guardian for help. If you are the parent or legal guardian of a minor who is creating an Account, you must accept these Terms of Use on the minor\'s behalf and you will be responsible for all use of the Account, whether such Account is currently open or created later. During the registration process, you are required to nominate a username, password and other personal information. You agree that we have the right to invalidate your username and password for the breach or potential breach of the Terms of Use herein, or of any laws and/or regulations and/or to ensure or maintain the security of the Sites which we deem reasonably appropriate, and that you will not hold us liable for any loss or damage which you may suffer as a result of such invalidation of your username and password. You agree to (a) keep your password confidential and use only your username and password when logging in, (b) ensure that you log out from your Account at the end of each session on the Sites, (c) immediately notify us of any unauthorised use of your Account, username and/or password, and (d) ensure that your Account information is accurate and up-to-date. You are fully responsible for all activities that occur under your username and Account even if such activities or uses were not committed by you. We will not be liable for any loss or damage arising from unauthorised use of your password or your failure to comply with this clause.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You shall not share, disclose, or otherwise permit any third party to access or use your Account, nor transfer or assign your Account to any other person.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may share our Sites to any other parties for informational or promotional purposes, provided that such sharing does not imply or suggest that our Sites endorses, sponsors, or is affiliated with you or any third party without prior written consent from us.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may also be required to provide us with information which we may deem necessary to effectively provide the Services to you. Such information includes, amongst other information, your name, address, phone number and email address.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree to provide accurate, current and complete information during the application process and update such information from time to time to keep your profile updated. We will be entitled to assume that there have been no changes or variations until we have received notice of such changes of your information from you.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'During the application process, we reserve the right and discretion to suspend, terminate or restrict your Account if:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'i. your use of the Sites breaches any applicable laws or regulations, or these Terms of Use;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'ii. you establish more than one profile for multiple applications;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'iii. you provided inaccurate and misleading information during the application process;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'iv. you become, threaten or resolve to become or are in jeopardy of becoming subject to any form of insolvency administration or bankruptcy;',
            'paddingLeft': '200pxpx',
            'underline': false
        },
        {
            'type': 2,
            'content': 'v. it is in the public of interest to do so;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'vi. we are required to facilitate investigation into matters pertaining to suspected fraudulent or unauthorized usage of your Account; and',
            'paddingLeft': '0px',
            'underline': false
        },{
            'type': 2,
            'content': 'vii. in our opinion, reasonable to do so.',
            'paddingLeft': '0px',
            'underline': false
        },{
            'type': 2,
            'content': 'Any rights and obligations under these Terms of Use shall survive the termination and suspension of these Terms of Use, and will continue to be in full force and effect after termination.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may terminate your Account by notifying us in writing. Notwithstanding any such termination, you remain responsible and liable for any incomplete transaction (whether commenced prior to or after such termination) with the Merchant. You shall remain responsible for completing and fulfilling any such transactions with the Merchant. We shall not be liable for any loss or damage arising from the termination of your Account or any action taken in accordance with this clause. By using the Services, you agree to waive any claims against us in relation to such actions.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1.3 Steps to Process the Applications:',
            'paddingLeft': '0px',
            'underline': false
        },

        {
            'type': 2,
            'content': 'We will undertake a credit underwriting process which may include a review of your credit information held with credit bureaus, analysis of your income and expense information and verification of your information with third parties which may include employer, governmental authorities, relevant authorities or other credit providers, (“Relevant Authorities”) whichever applicable. You give your consent and authorize us to reveal and disclose any information of you to the Relevant Authorities as part of the AITAB application process. We will protect and process all personal information supplied by you as part of the AITAB application process in accordance with the terms of our Privacy Policy.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'To obtain approval, you are required to:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'i. answer any additional questions from us, agree to undergo the identity verification and credit underwriting process;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'ii. complete the outstanding application form and upload required documentations to the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'iii. read and accept the Privacy Policy;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'iv. read and accept these Terms of Use; and',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'v. read and accept the Consent for Disclosure of Credit Information & Declaration.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'After assessing your AITAB application, we will inform you whether you are eligible to obtain the AITAB through the Sites.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If your AITAB application is approved, you will be required to accept the financing offer within thirty (30) days from the date of notification, failing which the offer may lapse.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Once you have accepted the financing offer by entering into a separate financing/loan agreement with us, you are required to conduct Electronic Know Your Customer (eKYC) process according to the requirements of the Sites. After the eKYC process, you shall proceed to complete the application with the chosen Merchant.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Notwithstanding of the above, we reserve the rights to amend, vary and adjust the terms and conditions in the financing offer within our absolute discretion.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If we subsequently suspect that you are or were, at the time of accepting the financing offer, in breach of these Terms of Use, we may, in our absolute discretion, withdraw the financing offer from you.',
            'paddingLeft': '0px',
            'underline': false
        },

        {
            'type': 1,
            'content': '1.4 Use of the Sites by the Merchant',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If you are a Merchant, you may create a separate account (“Separate Account”) operated by us. You acknowledge and agree that: (a) the purpose of the Separate Account is to enhance the management of your account as the Merchant, and you shall not use the Separate Account for any other purposes (including, but not limited to, fraudulent or illegal activities); (b) and you expressly acknowledge and agree that: (i) you are solely responsible for creating and configuring Separate Account, and granting and controlling third party access to the Separate Account; (ii) any third parties to whom you grant access to your Separate Account will have the ability to access and operate your Account; (iii) you shall be responsible for all actions of the Separate Account; and (iv) we reserve the right to amend or terminate the operation of the Separate Account and to close any Separate Account at any time in our sole discretion.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1.5 Marketing',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'From time to time, we may send you marketing material, this may include information on products, promotions and special offers which we may believe to be of interest to you.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1.6 MotoFin+',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'MotoFin+ is a feature integrated at our Sites that enables you to obtain a preliminary indication of your potential financing eligibility. You acknowledge and agree that any financing amount or eligibility indication provided through MotoFin+ is for informational and preliminary purposes only. Such amount does not constitute a final approval or commitment by us. All AITAB applications remain subject to our final review, assessment and approval upon submission of a complete application and supporting documents as stated in Clause 1.3.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The information and results provided through MotoFin+ are for general informational purposes only and do not constitute financial or professional advice. You should not rely solely on such information in making any financial decisions and are encouraged to seek independent professional advice where necessary. We make no representations or warranties as to the accuracy, completeness or suitability of any information or results generated by MotoFin+, and shall not be liable for any loss or damage arising from any reliance placed on such information or results by you.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1.7 Cancellation',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may cancel any AITAB application submitted through the Sites at any time prior to the execution of any financing or loan agreement with us. Once such agreement has been executed, the AITAB application may no longer be cancelled through the Sites, and any cancellation or termination shall be subject to the terms and conditions of the financing/loan agreement with us.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '2. Viruses, Hacking and other Offences',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '2.1 You agree that you will not (either yourself or through a third party):',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. use any robot, spider, screen scraper, data aggregation tool or other automatic device or process (“Automated Process”) to process, monitor, copy or extract any web pages on the Sites, or any of the information, content or data contained within or accessible through the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. use any Automated Process to aggregate or combine information, content or data contained within or accessible through the Sites with information, content or data accessible via or sourced from any third party;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. use any device, software (including but not limited to introducing a virus, a worm or other malicious code), process or routine to interfere or attempt to interfere with the proper working of the Sites or any transaction or process being conducted on or through it;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. take any action that imposes an unreasonable or disproportionately large load on the infrastructure of or bandwidth connecting to the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'e. reverse engineer, reverse assemble, decompile, or otherwise attempt to discover source code or other arithmetical formulae or processes in respect of the software underlying the infrastructure and processes associated with the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'f. copy, reproduce, alter, modify, create derivative works of, or publicly display, any part of any content from the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'g. post or otherwise distribute information on or through the Sites that would be in breach of another person’s intellectual property rights;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'h. post or otherwise distribute on or through the Sites any of the following forms of content the nature of which may be determined by us in our sole discretion:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '•  defamatory, obscene, harassing, threatening or other unlawful material or information; or',
            'paddingLeft': '20px',
            'underline': false
        },
        {
            'type': 2,
            'content': '•  photographs containing obscene images,',
            'paddingLeft': '20px',
            'underline': false
        },
         {
            'type': 2,
            'content': 'i. post or otherwise distribute on or through the Sites any information that is confidential to a third party without their permission; or',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'j. use the Sites for any other unlawful purpose or activity.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If we know or have reason to believe that you misuse the Sites, or commit any fraud, criminal offence or violation of any law or regulation in connection with the Sites, we may block or suspend your access to the Sites or your use of the Services immediately (without assigning any reasons or giving you prior notice).',
            'paddingLeft': '0px',
            'underline': false
        },

        {
            'type': 1,
            'content': '3.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '(a) Merchant’s Responsibilities',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Merchant shall be responsible in managing and ensuring that the accuracy of information such as the price, the specifications of motor vehicles, availability and information for sales is updated on the Sites and shall not post inaccurate or misleading information that may affect the Buyer’s AITAB application. Upon approval of the Buyer’s AITAB application, the Merchant shall honour and fulfil the sale of the motor vehicles in accordance with the agreed terms between the Buyer and the Merchant. The Merchant shall ensure that any motor vehicles sold to the Buyer is delivered in good condition and free from defects at the time of delivery.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Merchant acknowledges and agrees that the Sites act as a motor vehicles e-commerce platform operated by Shenma. Shenma provides the AITAB, while the Merchant will be supplying motor vehicles financed through Shenma.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Merchant shall regularly review and verify all information regarding their motor vehicles published on the Sites. The Merchant shall promptly notify Shenma of any errors, inaccuracies, or outdated information to ensure that the Buyer has accurate and up-to-date details. The Merchant acknowledges and agrees that the Merchant is solely responsible for handling all warranty claims, product defects, and any disputes arising from the motor vehicles sold to the Buyer and Shenma shall not be responsible or liable for any such claims or disputes.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Merchant shall conduct their business and use the Services provided by the Sites in a lawful, ethical and professional manner, in accordance with applicable laws and the Sites policies. The Merchant acknowledges and agrees that participation in promotional and marketing activities organized by Shenma, including co-funded campaigns, is voluntary, and shall comply with any rules or requirements specified for such activities. The Merchant shall not share, disclose, or transfer any personal information of any Buyer obtained through the Sites, except as permitted by applicable laws or with the prior written consent of Shenma.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '(b) Products Displayed on Website',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'All information available on the Sites, are provided on an “as is” and “as available” basis. The provision of details for motor vehicles at the Sites are not, and should not be construed as, an offer to sell or supply such motor vehicles and the Merchant may always accept or reject the Buyer’s selection at its sole discretion.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'All motor vehicles listed at the Sites are subject to availability and may be withdrawn without notice. All motor vehicles and all prices are also subject to change without notice.',
            'paddingLeft': '0px',
            'underline': false
        },

        {
            'type': 2,
            'content': 'Whilst Shenma has made every effort to ensure the information on the Sites are up to date, complete, true and accurate, Shenma expressly disclaim all liability for any errors, omissions or inadequacies in such information and will not accept responsibility for the Buyer’s reliance on any information on the Sites.',
            'paddingLeft': '0px',
            'underline': false
        },

        {
            'type': 2,
            'content': 'The model availability and information on motor vehicles model features, specifications, price and colours shall be confirmed by the Buyer with the Merchant directly. Shenma has no control over, and are not in any way responsible for, the existence, quality, safety or legality of the items listed on the Sites. Shenma does not accept any responsibility for any mistakes, errors or other faults in the Sites and the information, or for how the Buyer use the Sites and the information.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'All matters relating to the purchase, delivery and handover of any motor vehicles through the Sites shall be solely between the Buyer and the Merchant. In such circumstances, Shenma therefore has no liability to the Buyer for any losses that the Buyer may incur as a result of purchasing the motor vehicles from the Merchant through the Sites and Shenma shall not be responsible or liable for the delivery, condition, quality or fitness of the motor vehicles, or for any delay, failure or dispute arising from such delivery.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'In the event any issue or dispute arises between the Buyer and the Merchant, the Buyer agrees to communicate with the Merchant to resolve such dispute by mutual discussions. If the matter cannot be resolved by mutual discussions, the Buyer covenants and agrees that the Buyer will not bring suit or otherwise assert any claim against Shenma in relation to any purchase transaction made on the Sites or any dispute related to such purchase transaction between the Buyer and the Merchant.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '4. Website Availability',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We do not warrant that your access to the Sites will be uninterrupted, unrestricted, timely, secure and error-free and we do not make any promises about the availability or accessibility of the Sites or promise that your access to the Sites, the content on it or the Services we provide will be delivered uninterrupted, in a timely manner or error-free (and we may suspend, restrict or terminate your access to the Sites at any time), or that the Sites and the server are free of computer viruses or other harmful applications.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You are responsible for configuring your information technology, computer programs and platform in order to access the Sites.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '5. Links to Third Party Websites',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The Sites may contain external links/hyperlinks to other sites that enable users to leave the Sites and go directly to the linked site (“Third Party Websites”) which are not under our control.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'These Third Party Websites are provided for your convenience and any inclusion of such link does not imply endorsement by us of a website or any association with the operators of a website. We are not responsible for any Third Party Websites and disclaims any liability for the privacy practices or the content of the Third Party Websites. If you have decided to access any of these Third Party Websites, you will access entirely at your own risk. We will therefore not be liable for (a) your access to and use of such websites; (b) any services, information or materials available on such websites or your use of the same; or (c) any transaction, transmission or communication between you and such third parties.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If you use these Third Party Websites, any personal information you provided to these Third Party Websites will be dealt with in line with their own privacy policy.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '6. Representations and Warranties',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You acknowledge and agree that you:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. are solely responsible for all results of your actions and inactions from your use of the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. will not allow any other person to use your profile; and',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. will not disguise or interfere in any way with the IP address of the computer you are using to access the Sites or otherwise take steps to prevent us from correctly identifying the our IP address of the computer you are using whilst accessing the Sites.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You represent and warrant that the information you provide as part of any registration or application process using these Website is true and correct and that you are the person whose details you have provided in connection with your profile.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '7. Indemnity',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree to indemnify and hold us and our associated companies, affiliates, officers, directors, agents and employees harmless from any liabilities, claims, losses or demands arising out of:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. any falsehood or inaccuracy contained in any information you provided us; or',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. another person using or trading on your profile (whether or not authorized by you);',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. any failure by you to comply with any of these Terms of Use;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. your negligent and fraudulent acts.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree and acknowledge that your obligation to indemnify us will survive the termination of your use of the Sites.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '8. Exclusion of Liability',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree and acknowledge that we do not make any warranties or representations of any kind (whether express or implied) in relation to the information, content, products, or Services included in the Sites. We will not be responsible or liable for any loss whether arising in tort, contract, indemnity or otherwise, in regards to the Sites and your performance of obligations under the Terms of Use whether suffered by you or any other person.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'To the extent permitted by law, we will not be liable for any loss caused by or arising from one or more of the following events however caused or incurring:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. any loss or damage, however caused (including through negligence), which you may directly or indirectly suffer in connection with your use of the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. any condition, warranty or guarantee which would otherwise be implied by these terms is hereby excluded;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. any malfunction, disruption of the Sites;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'd. any intrusion or hacking by other person;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'e. any inaccuracy or incompleteness of information provided by you;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'f. our reliance of any information received from you;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'g. your failure to act in accordance with these Terms of Use;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'h. your failure to act in accordance with any other rules, regulations and guidelines;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'i. any delay due to your inactions to complete the documentations;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'j. any loss which is caused by third parties; or',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'k. any other reasons not specified herein.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'To the extent permitted by law, we will have no liability for:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'a. Not exercising reasonable skill and care in determining your eligibility to borrow facility/loan from us;',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'b. Not displaying our approval on the Sites, for withdrawing the approval for your AITAB application; or',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'c. Any loss or damage that you may suffer because of any matter beyond our reasonable control including any: act of God; power cut; trade or labour dispute; act, failure or omission of any government or authority; obstruction or failure of telecommunication Services; or any other delay or failure caused by a third party. In such an event, we reserve the right to cancel or suspend your application without incurring any liability.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'In no event we will be liable to you for any consequential, indirect, special, incidental, exemplary or punitive damages or losses (including, without limitation, loss of earnings, loss of profits, loss of revenue, loss of income, loss of savings, loss of production, loss of value or decrease in earnings, loss of use, loss of financial advantage, loss of reputation, loss of business, loss of goodwill, business interruption or downtime, or destruction, loss of use or corruption of data, software or system) arising out of or related to these Terms of Use.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '9. Intellectual Property',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The names, logos and images on the Sites which identify any Shenma companies, or third parties and their products and Services are proprietary marks of Shenma and/or the relevant third parties. Nothing contained in the Sites shall be deemed to confer on any person any licence or right on the part of Shenma Group of companies or any third party with respect to any such name, logo or image.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The products and Services or processes described in the Sites may be subject to other intellectual property rights reserved by Shenma or their licensors or any relevant third parties. No licence is granted in respect of such intellectual property rights.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We own all rights in any price data and related content on the Sites. Your registration and use of the Sites confers no rights whatsoever to the content and related intellectual property rights contained in the Sites. You agree not to monitor, use or copy our web pages or any content on the Sites, including without limitation any price data.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Any such unauthorized reproduction, retransmission, copying or modification of any of the information of the Sites may be in breach of statutory or common law rights which could be the subject of legal action.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We disclaim all liability which may arise from any unauthorised reproduction or use of the information of the Sites.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '10. Queries',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If you wish to make any queries or reach out to us in relation to the Sites or the Services, you may contact Consumer Service Unit through email or call us at the following email address and contact number:-',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'Consumer Service Unit',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'Contact Number: +604 523 0033',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 3,
            'content': 'Email: wecare@shenmacredit.com.my',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 1,
            'content': '11. Severability',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'To the extent permitted by applicable law, the parties hereby waive any provision of law that would render any provision of these Terms of Use invalid or otherwise unenforceable in any respect. If any provision of these Terms of Use is held to be invalid or otherwise unenforceable in any jurisdiction, such provision shall, as to such jurisdiction, be modified so as to effect the original intent of the parties with respect to such provision as closely as possible to the fullest extent permitted by applicable law, without affecting the validity and enforceability of such provision in any other jurisdictions and of the remaining provisions of these Terms of Use.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '12. Waiver',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If we fail or neglect to enforce any provision or remedy under these Terms of Use for any reason, we will not be construed as having waived our rights to enforce the same or as having waived our rights in relation to any continuing or subsequent breach of the same or any other provision in these Terms of Use.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '13. Governing Law',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'These Terms of Use will be governed solely by the laws of Malaysia without regard to the conflict of law principles. By accessing this Website, you hereby consent to the exclusive jurisdiction of the Malaysian courts in Kuala Lumpur, Malaysia in all disputes arising out of relating to the use of this Website.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The performance of our obligations under these Terms of Use is subject always to all applicable laws and regulations. Nothing contained in these Terms of Use diminishes our rights to act so as to comply with and conform to any governmental requests or legal requirements relating to access to the Sites and use of the Services, or relating to any content provided to you or acquired by us for your use. We make no representation that the materials, information or Services provided on the Sites are appropriate or available for use in other jurisdictions other than Malaysia.',
            'paddingLeft': '0px',
            'underline': false
        },

    
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>{content}</Typography>
            </Grid>
        )
    }
    
    // 文字前有圆点样式
    const bulletItem = (index: number, content: string, paddingLeft: string) => {
        return (
            <Grid key={index} item xs={12} sx={{ mt: '-4px' }}>
                <Typography
                    fontSize={isDesktop ? 18 : 14}
                    color={'#333333'}
                    sx={{
                        paddingLeft: '20px',
                        textIndent: '-16px',
                        paddingRight: '16px',
                        whiteSpace: 'pre-line',
                        lineHeight: 0.8, // 控制文字内部行间距，越小越紧凑
                        '&::before': {
                            content: '"•"',
                            marginRight: '8px',
                            fontSize: '1.5em', // 放大圆点，1.2~1.5之间自己调
                            fontWeight: 'bold', // 加粗，圆点更粗更明显
                        }
                    }}
                >
                    {content}
                </Typography>
            </Grid>
        )
    }
    
    return (
        <Box sx={{
        width: '100%',
        paddingTop: isDesktop ? '60px' : '30px',
        paddingBottom: '60px',
        paddingLeft: isDesktop ? '100px' : '20px',
        paddingRight: isDesktop ? '100px' : '20px',
        }}>
        <Grid container rowSpacing={2}>
            {data.map((item, index) => {
                // 改用函数体，内部写if判断
                if (item.type === 1) {
                    return titleItem(index, item.content, item.paddingLeft, item.underline)
                } else if (item.type === 2) {
                    return contentItem(index, item.content, item.paddingLeft, item.underline)
                } else if (item.type === 3) {
                    return bulletItem(index, item.content, item.paddingLeft)
                }
                // 兜底防止返回undefined
                return null
            })}
        </Grid>
    </Box>
    )
}
